import { Component, EventEmitter, Output,Injectable,OnInit } from '@angular/core';
import { ContextMenuService } from './context-menu.service';
import { ConversationService } from 'src/app/services/conversation.service';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
})
export class ContextMenuComponent implements OnInit {
  @Output() markAsRead = new EventEmitter<void>();
  @Output() copyTextBubble = new EventEmitter<void>();
  @Output() markAsUnread = new EventEmitter<void>();

  visible = false;
  position = { x: 0, y: 0 };
  public ToggleRightClick=false;

  public Reply_Selected=false;
  conversationId: string | null = null; // To store the conversation ID

  constructor(private contextMenuService: ContextMenuService,
    private convoService: ConversationService
  ) {}
  // @Output() select = new EventEmitter<void>();
  // @Output() reply = new EventEmitter<void>();

  ngOnInit() {
    this.contextMenuService.contextMenuState$.subscribe(state => {
      this.visible = state.visible;
      this.position = { x: state.x, y: state.y };
    });
  }
  show(x: number, y: number, conversationId: string): void {
    this.position = { x, y};
    this.conversationId = conversationId; // Set the message ID
    this.visible = true;
  }
  closeMenu() {
    this.contextMenuService.closeContextMenu();
  }

  deleteMessage() {
    // Implement delete message functionality
    this.closeMenu();
  }


  onSelect(): void {
    if (this.ToggleRightClick==true){
      this.ToggleRightClick=false;
    }
    else{
      this.ToggleRightClick=true;
    }
    this.convoService.emitSelectAction();
    this.deleteMessage();
  }



  ReplyText():void{
    this.Reply_Selected=true;
    this.convoService.emitReplyAction(this.Reply_Selected);
    this.deleteMessage();

  }



  markasread():void{
  //   if(!confirm('Mark message as read?')) {
  //     return;
  // }

  this.convoService
      .setConversationMessageread(this.conversationId)
      .subscribe((resp) => {
          this.markAsRead.emit();
      });
  }

  markasunread():void{

this.markAsUnread.emit()
  }

  CopyText():void{
    this.copyTextBubble.emit();
  }
}
